import {UseFormReturn} from 'react-hook-form';

import {getSafely} from 'shared/web';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormResetActionParams {
  form: UseFormReturn<BaseVehicle>;
  fieldsToReset?: Array<keyof BaseVehicle>;
}

/**
 * Generic action for resetting specified form fields to null
 * @param _ - XState context (unused)
 * @param params - Parameters containing form instance and fields to reset
 */
export const formResetAction = (_context: unknown, params: FormResetActionParams): void => {
  const {form, fieldsToReset} = params;

  if (!fieldsToReset || fieldsToReset?.length === 0) {
    // Reset all fields
    form.reset(undefined, {keepDirty: true, keepTouched: true});
    return;
  }

  const currentValues = form.getValues();

  fieldsToReset.forEach((fieldName) => {
    const defaultValue = Array.isArray(getSafely(currentValues, fieldName)) ? [] : null;
    form.setValue(fieldName, defaultValue, {
      shouldDirty: false,
      shouldValidate: false,
    });
  });
};
